"use strict";
function escapeRegexp(queryToEscape) {
    return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
}
exports.escapeRegexp = escapeRegexp;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-select/select/common.js
// module id = 39
// module chunks = 0 1